import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiBaseService } from "../../common/providers/api-base-service";
import { MacroCycle } from "../../common/models/macro-cycle";
import { Organization } from "../../common/models/organization";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({providedIn: 'root'})
export class MacrocycleProvider {
    constructor(
        private api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {}

    public findAll(organization: Organization): Observable<MacroCycle[]> {
        return this.api.call('get',`organizations/${organization.code}/plans/macrocycles`, {}, this.currentUser.getAccessToken()).pipe(
            map((macroCycles) =>  macroCycles.map((macroCycle: MacroCycle) => MacroCycle.fromAPI(macroCycle, [macroCycle])))
        );
    }
}
